import React from 'react'

export default ({ messages, bem, storeCredit }) => {
    return (
        <>
            <div className={bem('store-credit')}>
                <span>{messages.paymentOptionsForm.storeCredit.label()}</span>
                <span className={bem('store-credit-amount')}>{messages.paymentOptionsForm.storeCredit.amount(storeCredit)}</span>
            </div>
            <div className={bem('store-credit-info')}>{messages.paymentOptionsForm.storeCredit.description()}</div>
        </>
    )
}
